module.exports = __webpack_public_path__ + "assets/c568cec0896e5a818508457cf06bc959.png";